import { SubscriptionBillingTermEnum } from '~/generated/graphql';

import { ChartData, ChartDatum } from './types';

type BottomAxisValuesProps = {
  chartData: ChartData[];
  granularity?: number;
  usageTerm?: SubscriptionBillingTermEnum;
};

const DEFAULT_GRANULARITY = 3;
const ANNUAL_GRANULARITY = 14;

export const formatBottomAxisValues = ({
  chartData,
  usageTerm,
  granularity = DEFAULT_GRANULARITY,
}: BottomAxisValuesProps) => {
  let rollupWindow = (_item: ChartDatum, index: number) =>
    index % granularity === 0;

  if (usageTerm === SubscriptionBillingTermEnum.Yearly) {
    rollupWindow = (_item: ChartDatum, index: number) =>
      index % ANNUAL_GRANULARITY === 1;
  }

  chartData[0]?.data.filter(rollupWindow).map((item: ChartDatum) => item.x);
};
